
const customFormatters = {

  fomatterUserType (value) {
    if (value === 'student') {
      return '학생'
    } else if (value === 'teacher') {
      return '강사'
    } else if (value === 'instchief') {
      return '학원장'
    } else if (value === 'sysadmin') {
      return '관리자'
    } else {
      return value
    }
  },
  fomatterStatus (value) {
    if (value === 0) {
      return '정상'
    } else if (value === 1) {
      return '탈퇴'
    } else {
      return value
    }
  },
  fomatterStudentStatus (value) {
    if (value === 0) {
      return '정상'
    } else if (value === 1) {
      return '퇴원'
    } else {
      return value
    }
  }
}

export default customFormatters
